import * as FileSaver from "file-saver";

import * as XLSX from "xlsx";

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const fileExtension = ".xlsx";

const exportToCSV = ({ csvData, fileName }) => {
  const ws = XLSX.utils.json_to_sheet(csvData);

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  const data = new Blob([excelBuffer], { type: fileType });

  FileSaver.saveAs(data, fileName + fileExtension);
};

//read xlsx file first sheet
//convert into array of json
const csvToJSON = ({ csv }) => {
  try {
    //console.log(csv);
    const workbook = XLSX.read(csv, { type: "binary" });
    //console.log(workbook);

    const sheetName = workbook.SheetNames[0];
    //console.log(sheetName);

    const worksheet = workbook.Sheets[sheetName];
    //console.log(worksheet);

    const sheetArray = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    //console.log(sheetArray);

    //parse
    const headers = sheetArray[0];
    let data = sheetArray.slice(1);
    data = data.map((row) => {
      const obj = {};

      row.forEach((value, index) => {
        obj[headers[index]] = value;
      });
      
      return obj;
    });

    return { status: "Success", data: data };
  } catch (error) {
    return { status: "Error", error };
  }
};

export default { exportToCSV, csvToJSON };
